<template>
  <router-view />
</template>

<script>
export default {
  name: 'Business'
}
</script>
